import { Spinner } from '../../assets/icon/svg';

interface Props {
    title?: string;
    description?: string;
    spinnerColor?: string;
    spinnerSize?: number;
}

export default function TableLoading({
    title = 'Loading records',
    description = 'Please wait while we retrieve your records.',
    spinnerColor = '#186cb2',
    spinnerSize = 25,
}: Props) {
    return (
        <tr>
            <td className="p-0" colSpan={999}>
                <div className="flex min-h-[320px] w-full items-center justify-center px-4">
                    <div className="flex flex-col items-center justify-center text-center">
                        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#186cb2]/20 bg-[#186cb2]/5">
                            <Spinner color={spinnerColor} size={spinnerSize} />
                        </div>
                        <div className="mt-3">
                            <p className="text-xs font-medium text-gray-800">{title}</p>
                            <p className="mt-0.5 text-xs text-gray-400">{description}</p>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
}